import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { ITaskSummary, TaskSummary } from '../Tasks.ts';
import { TasksApi } from '../../../apis/TasksApi/TasksApi.ts';
import { patientStore } from '../../../Store/Store.ts';
import { useTranslation } from 'react-i18next';

export function useGetTaskSummaries() {
    const patientId = patientStore.patientId;
    const { i18n } = useTranslation();

    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.taskSummaries, patientId, i18n.language],
        queryFn: async () => {
            const result: ITaskSummary[] = await TasksApi.getTaskSummaries(patientId!);
            return result ? result.map((x: ITaskSummary) => new TaskSummary(x)) : result;
        },

        enabled: !!patientId,
    });
}
